export const httpMessage = {
    responses: {
        actions: {
            added: "action/added",
            alreadyAdded: "action/already-added",
            exists: "action/exists",
            notFound: "action/not-found",
            invalid: {
                category: "action/category-invalid",
                id: "action/id-invalid",
                ipAddress: "action/ip-address-invalid",
                name: "action/name-invalid",
            },
            required: {
                category: "action/category-required",
                id: "action/id-required",
                ipAddress: "action/ip-address-required",
                name: "action/name-required",
            },
        },
        users: {
            added: "user/added",
            exists: "user/exists",
            notFound: "user/not-found",
            notAuthenticated: "user/not-authenticated",
            updated: "user/updated",
            deleted: "user/deleted",
            invited: "user/invited",
            invalid: {
                email: "user/email-invalid",
                id: "user/id-invalid",
                name: "user/name-invalid",
                cellPhone: "user/cell-phone-invalid",
                darkModeEnabled: "user/dark-mode-enabled-invalid",
                contentNotificationsEmailEnabled: "user/content-notifications-email-enabled-invalid",
                contentNotificationsSmsEnabled: "user/content-notifications-sms-enabled-invalid",
                engagementNotificationsEmailEnabled: "user/engagement-notifications-email-enabled-invalid",
                engagementNotificationsSmsEnabled: "user/engagement-notifications-sms-enabled-invalid",
                generalNotificationsEmailEnabled: "user/general-notifications-email-enabled-invalid",
                generalNotificationsSmsEnabled: "user/general-notifications-sms-enabled-invalid",
                permissions: "user/permissions-invalid",
                photoSettings: "user/photo-settings-invalid",
                photoUrl: "user/photo-url-invalid",
                originalPhotoUrl: "user/original-photo-url-invalid",
                workPhone: "user/work-phone-invalid",
                role: "user/role-invalid",
                status: "user/status-invalid",
            },
            required: {
                email: "user/email-required",
                id: "user/id-required",
                name: "user/name-required",
                cellPhone: "user/cell-phone-required",
                darkModeEnabled: "user/dark-mode-enabled-required",
                contentNotificationsEmailEnabled: "user/content-notifications-email-enabled-required",
                contentNotificationsSmsEnabled: "user/content-notifications-sms-enabled-required",
                engagementNotificationsEmailEnabled: "user/engagement-notifications-email-enabled-required",
                engagementNotificationsSmsEnabled: "user/engagement-notifications-sms-enabled-required",
                generalNotificationsEmailEnabled: "user/general-notifications-email-enabled-required",
                generalNotificationsSmsEnabled: "user/general-notifications-sms-enabled-required",
                photoSettings: "user/photo-settings-required",
                photoUrl: "user/photo-url-required",
                originalPhotoUrl: "user/original-photo-url-required",
                workPhone: "user/work-phone-required",
                role: "user/role-required",
                status: "user/status-required",
            },
            tooLong: {
                name: "user/name-too-long",
            },
        },
        userProfiles: {
            invalid: {
                id: "user-profiles/id-invalid",
                firstName: "user-profiles/first-name-invalid",
                lastName: "user-profiles/last-name-invalid",
                title: "user-profiles/title-invalid",
                timezone: "user-profiles/timezone-invalid",
                email: "user-profiles/email-invalid",
                phone: "user-profiles/phone-invalid",
                image: "user-profiles/image-invalid",
                introduction: "user-profiles/introduction-invalid",
                showImage: "user-profiles/show-image-invalid",
                showWorkPhone: "user-profiles/show-work-phone-invalid",
                showCellPhone: "user-profiles/show-cell-phone-invalid",
                showEmail: "user-profiles/show-email-invalid",
            },
            tooLong: {
                firstName: "user-profiles/first-name-too-long",
                lastName: "user-profiles/last-name-too-long",
                introduction: "user-profiles/introduction-too-long",
            },
            required: {
                id: "user-profiles/id-required",
                firstName: "user-profiles/first-name-required",
                lastName: "user-profiles/last-name-required",
                title: "user-profiles/title-required",
                email: "user-profiles/email-required",
                phone: "user-profiles/phone-required",
                image: "user-profiles/image-required",
                introduction: "user-profiles/introduction-required",
                showImage: "user-profiles/show-image-required",
                showWorkPhone: "user-profiles/show-work-phone-required",
                showCellPhone: "user-profiles/show-cell-phone-required",
                showEmail: "user-profiles/show-email-required",
            },
            unsupportedFileFormat: {
                image: "user-profiles/image-unsupported-file-format",
            },
            invalidDimensions: {
                image: "user-profiles/image-invalid-dimensions",
            },
            fileSizeExceeds: {
                image: "user-profiles/image-file-size-exceeds",
            },
        },
        roles: {
            added: "roles/added",
            deleted: "roles/deleted",
            exists: "roles/exists",
            updated: "roles/updated",
            notFound: "roles/not-found",
            invalid: {
                description: "roles/description-invalid",
                id: "roles/id-invalid",
                title: "roles/title-invalid",
            },
            required: {
                description: "roles/description-required",
                id: "roles/id-required",
                title: "roles/title-required",
            },
        },
        phones: {
            added: "phone/added",
            deleted: "phone/deleted",
            exists: "phone/exists",
            updated: "phone/updated",
            notFound: "phone/not-found",
            invalid: {
                code: "phone/code-invalid",
                iso: "phone/iso-invalid",
                number: "phone/number-invalid",
                type: "phone/type-invalid",
            },
            required: {
                code: "phone/code-required",
                iso: "phone/iso-required",
                number: "phone/number-required",
                type: "phone/type-required",
            },
        },
        permissions: {
            added: "permissions/added",
            deleted: "permissions/deleted",
            denied: "permissions/denied",
            exists: "permissions/exists",
            updated: "permissions/updated",
            notFound: "permissions/not-found",
            invalid: {
                action: "permissions/action-invalid",
                id: "permissions/id-invalid",
                resource: "permissions/resource-invalid",
            },
            required: {
                action: "permissions/action-required",
                id: "permissions/id-required",
                resource: "permissions/resource-required",
            },
        },
    },
};
// Reference for transcription of missing artifacts in httpMessage
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const RES_MESSAGES = {
    ACTION_OBJECT_INVALID: "action/object-invalid",
    ACTION_OBJECT_NAME_INVALID: "action/object-name-invalid",
    ACTION_OBJECT_NAME_REQUIRED: "action/object-name-required",
    ACTION_OBJECT_NAMES_INVALID: "action/object-names-invalid",
    ACTION_OBJECT_NAMES_REQUIRED: "action/object-names-required",
    ACTION_OBJECT_REQUIRED: "action/object-required",
    ACTION_ORIGIN_INVALID: "action/origin-invalid",
    ACTION_ORIGIN_REQUIRED: "action/origin-required",
    ACTION_SHOULD_FORCE_NOTIFY_INVALID: "action/should-force-notify-invalid",
    ACTION_SHOULD_FORCE_NOTIFY_REQUIRED: "action/should-force-notify-required",
    ANALYTICS_END_DATE_INVALID: "analytics/end-date-invalid",
    ANALYTICS_END_DATE_REQUIRED: "analytics/end-date-required",
    ANALYTICS_START_DATE_INVALID: "analytics/start-date-invalid",
    ANALYTICS_START_DATE_REQUIRED: "analytics/start-date-required",
    ANALYTICS_CHIP_SELECTED_INVALID: "analytics/chip-selected-invalid",
    ANALYTICS_CHIP_SELECTED_REQUIRED: "analytics/chip-selected-required",
    BRANDING_ADDRESS_1_INVALID: "branding/address-1-invalid",
    BRANDING_ADDRESS_1_REQUIRED: "branding/address-1-required",
    BRANDING_ADDRESS_2_INVALID: "branding/address-2-invalid",
    BRANDING_ADDRESS_2_REQUIRED: "branding/address-2-required",
    BRANDING_CITY_INVALID: "branding/city-invalid",
    BRANDING_CITY_REQUIRED: "branding/city-required",
    BRANDING_COUNTRY_INVALID: "branding/country-invalid",
    BRANDING_COUNTRY_REQUIRED: "branding/country-required",
    BRANDING_ID_INVALID: "branding/id-invalid",
    BRANDING_ID_REQUIRED: "branding/id-required",
    BRANDING_LOGO_FAVICON_INVALID: "branding/logo-favicon-invalid",
    BRANDING_LOGO_FAVICON_REQUIRED: "branding/logo-favicon-required",
    BRANDING_NOT_FOUND: "branding/not-found",
    BRANDING_POSTAL_CODE_INVALID: "branding/postal-code-invalid",
    BRANDING_POSTAL_CODE_REQUIRED: "branding/postal-code-required",
    BRANDING_PREVIEW_IMAGE_URL_INVALID: "branding/preview-image-url-invalid",
    BRANDING_PREVIEW_IMAGE_URL_REQUIRED: "branding/preview-image-url-required",
    BRANDING_SETTINGS_INVALID: "branding/settings-invalid",
    BRANDING_SETTINGS_REQUIRED: "branding/settings-required",
    BRANDING_SPLASH_PAGE_BACKGROUND_COLOR_INVALID: "branding/splash-page-background-color-invalid",
    BRANDING_SPLASH_PAGE_BACKGROUND_COLOR_REQUIRED: "branding/splash-page-background-color-required",
    BRANDING_SPLASH_PAGE_DURATION_INVALID: "branding/splash-page-duration-invalid",
    BRANDING_SPLASH_PAGE_DURATION_REQUIRED: "branding/splash-page-duration-required",
    BRANDING_SPLASH_PAGE_LOGO_INVALID: "branding/splash-page-logo-invalid",
    BRANDING_SPLASH_PAGE_LOGO_REQUIRED: "branding/splash-page-logo-required",
    BRANDING_STATE_INVALID: "branding/state-invalid",
    BRANDING_STATE_REQUIRED: "branding/state-required",
    BRANDING_THEME_COLOR_INVALID: "branding/theme-color-invalid",
    BRANDING_THEME_COLOR_REQUIRED: "branding/theme-color-required",
    BRANDING_UPDATED: "branding/updated",
    COACH_ADMIN_EXISTS: "coach_admin_exists",
    COLLECTION_ADDED: "collection/added",
    COLLECTION_ID_INVALID: "collection/id-invalid",
    COLLECTION_ID_REQUIRED: "collection/id-required",
    COLLECTION_NOT_FOUND: "collection/not-found",
    COLLECTION_UPDATED: "collection/updated",
    CONTACT_ACTIVITY_INVALID: "contact/activity-invalid",
    CONTACT_ACTIVITY_REQUIRED: "contact/activity-required",
    CONTACT_ADDED: "contact/added",
    CONTACT_DELETED: "contact/deleted",
    CONTACT_EMAIL_INVALID: "contact/email-invalid",
    CONTACT_EMAIL_REQUIRED: "contact/email-required",
    CONTACT_ID_INVALID: "contact/id-invalid",
    CONTACT_ID_REQUIRED: "contact/id-required",
    CONTACT_IDS_INVALID: "contact/ids-invalid",
    CONTACT_IDS_REQUIRED: "contact/ids-required",
    CONTACT_NAME_INVALID: "contact/first-name-invalid",
    CONTACT_NAME_REQUIRED: "contact/name-required",
    CONTACT_NEXT_ACTION_DATE_INVALID: "contact/next-action-date-invalid",
    CONTACT_NEXT_ACTION_DATE_REQUIRED: "contact/next-action-date-required",
    CONTACT_NOT_FOUND: "contact/not-found",
    CONTACT_NOTE_ADDED: "contact-note/added",
    CONTACT_NOTE_CONTACT_ID_INVALID: "contact-note/contact-id-invalid",
    CONTACT_NOTE_CONTACT_ID_REQUIRED: "contact-note/contact-id-required",
    CONTACT_NOTE_CONTENT_INVALID: "contact-note/content-invalid",
    CONTACT_NOTE_CONTENT_REQUIRED: "contact-note/content-required",
    CONTACT_NOTE_DELETED: "contact-note/deleted",
    CONTACT_NOTE_ID_INVALID: "contact-note/id-invalid",
    CONTACT_NOTE_ID_REQUIRED: "contact-note/id-required",
    CONTACT_NOTE_NAME_INVALID: "contact-note/name-invalid",
    CONTACT_NOTE_NAME_REQUIRED: "contact-note/name-required",
    CONTACT_NOTE_NOT_FOUND: "contact-note/not-found",
    CONTACT_NOTE_TYPE_INVALID: "contact-note/type-invalid",
    CONTACT_NOTE_TYPE_REQUIRED: "contact-note/type-required",
    CONTACT_NOTE_UPDATED: "contact-note/updated",
    CONTACT_PHONE_INVALID: "contact/phone-invalid",
    CONTACT_PHONE_REQUIRED: "contact/phone-required",
    CONTACT_STATUS_INVALID: "contact/status-invalid",
    CONTACT_STATUS_REQUIRED: "contact/status-required",
    CONTACT_UPDATED: "contact/updated",
    CONTENT_TYPE_ADDED: "content-type/added",
    CONTENT_TYPE_BULK_UPDATED: "content-type/bulk-updated",
    CONTENT_TYPE_DELETED: "content-type/deleted",
    CONTENT_TYPE_HIDDEN_INVALID: "content-type/hidden-invalid",
    CONTENT_TYPE_HIDDEN_REQUIRED: "content-type/hidden-required",
    CONTENT_TYPE_ID_INVALID: "content-type/id-invalid",
    CONTENT_TYPE_ID_REQUIRED: "content-type/id-required",
    CONTENT_TYPE_IDS_INVALID: "content-type/ids-invalid",
    CONTENT_TYPE_IDS_REQUIRED: "content-type/ids-required",
    CONTENT_TYPE_NAME_INVALID: "content-type/name-invalid",
    CONTENT_TYPE_NAME_REQUIRED: "content-type/name-required",
    CONTENT_TYPE_NOT_FOUND: "content-type/not-found",
    CONTENT_TYPE_ORDER_INVALID: "content-type/order-invalid",
    CONTENT_TYPE_ORDER_REQUIRED: "content-type/order-required",
    CONTENT_TYPE_UPDATED: "content-type/updated",
    ELEMENT_ADDED: "element/added",
    ELEMENT_COLOR_INVALID: "element/color-invalid",
    ELEMENT_COLOR_REQUIRED: "element/color-required",
    ELEMENT_DELETED: "element/deleted",
    ELEMENT_FILE_NAME_INVALID: "element/title-invalid",
    ELEMENT_FILE_NAME_REQUIRED: "element/title-required",
    ELEMENT_FILE_SIZE_INVALID: "element/file-size-invalid",
    ELEMENT_FILE_SIZE_REQUIRED: "element/file-size-required",
    ELEMENT_HELPER_TEXT_INVALID: "element/helper-text-invalid",
    ELEMENT_HELPER_TEXT_REQUIRED: "element/helper-text-required",
    ELEMENT_ICON_LINK_INVALID: "element/icon-link-invalid",
    ELEMENT_ICON_LINK_REQUIRED: "element/icon-link-required",
    ELEMENT_ICON_NAME_INVALID: "element/icon-name-invalid",
    ELEMENT_ICON_NAME_REQUIRED: "element/icon-name-required",
    ELEMENT_ID_INVALID: "element/id-invalid",
    ELEMENT_ID_REQUIRED: "element/id-required",
    ELEMENT_LINK_DESTINATION_INVALID: "element/link-destination-invalid",
    ELEMENT_LINK_DESTINATION_REQUIRED: "element/link-destination-required",
    ELEMENT_LINKED_ID_INVALID: "element/linked-id-invalid",
    ELEMENT_MEMO_METHOD_INVALID: "element/memo-method-invalid",
    ELEMENT_MEMO_METHOD_REQUIRED: "element/memo-method-required",
    ELEMENT_NOT_FOUND: "element/not-found",
    ELEMENT_POSITIONING_INVALID: "element/positioning-invalid",
    ELEMENT_POSITIONING_REQUIRED: "element/positioning-required",
    ELEMENT_SCOPE_INVALID: "element/scope-invalid",
    ELEMENT_SCOPE_REQUIRED: "element/scope-required",
    ELEMENT_SHAPE_INVALID: "element/shape-invalid",
    ELEMENT_SHAPE_REQUIRED: "element/shape-required",
    ELEMENT_SHOW_TEXT_INVALID: "element/show-text-invalid",
    ELEMENT_SHOW_TEXT_REQUIRED: "element/show-text-required",
    ELEMENT_SIZE_INVALID: "element/size-invalid",
    ELEMENT_SIZE_REQUIRED: "element/size-required",
    ELEMENT_STATUS_INVALID: "element/status-invalid",
    ELEMENT_STATUS_REQUIRED: "element/status-required",
    ELEMENT_TEXT_COLOR_INVALID: "element/text-color-invalid",
    ELEMENT_TEXT_COLOR_REQUIRED: "element/text-color-required",
    ELEMENT_TITLE_INVALID: "element/title-invalid",
    ELEMENT_TITLE_REQUIRED: "element/title-required",
    ELEMENT_TYPE_INVALID: "element/type-invalid",
    ELEMENT_TYPE_REQUIRED: "element/type-required",
    ELEMENT_UPDATED: "element/updated",
    ELEMENT_URL_INVALID: "element/url-invalid",
    ELEMENT_URL_REQUIRED: "element/url-required",
    ELEMENT_X_FRAME_OPTIONS_INVALID: "element/x-frame-options-invalid",
    ELEMENT_X_FRAME_OPTIONS_REQUIRED: "element/x-frame-options-required",
    EXPERIENCE_ACTIVITY_INVALID: "experience/activity-invalid",
    EXPERIENCE_ACTIVITY_REQUIRED: "experience/activity-required",
    EXPERIENCE_ADDED: "experience/added",
    EXPERIENCE_BULK_DELETED: "experience/bulk-deleted",
    EXPERIENCE_CAROUSEL_INVALID: "experience/carousel-invalid",
    EXPERIENCE_CAROUSEL_REQUIRED: "experience/carousel-required",
    EXPERIENCE_CONTACT_ADDED: "experience-contact/added",
    EXPERIENCE_CONTACT_BULK_ADDED: "experience-contact/bulk-added",
    EXPERIENCE_CONTACT_BULK_DELETED: "experience-contact/bulk-deleted",
    EXPERIENCE_CONTACT_DELETED: "experience-contact/deleted",
    EXPERIENCE_CONTACT_EXISTS: "experience-contact/exists",
    EXPERIENCE_CONTACT_ID_INVALID: "experience-contact/id-invalid",
    EXPERIENCE_CONTACT_ID_REQUIRED: "experience-contact/id-required",
    EXPERIENCE_CONTACT_NOT_FOUND: "experience-contact/not-found",
    EXPERIENCE_CONTENT_TYPE_ADDED: "experience-content-type/added",
    EXPERIENCE_CONTENT_TYPE_EXISTS: "experience-content-type/exists",
    EXPERIENCE_CONTENT_TYPE_HIDDEN_INVALID: "experience-content-type/hidden-invalid",
    EXPERIENCE_CONTENT_TYPE_HIDDEN_REQUIRED: "experience-content-type/hidden-required",
    EXPERIENCE_CONTENT_TYPE_ID_INVALID: "experience-content-type/id-invalid",
    EXPERIENCE_CONTENT_TYPE_ID_REQUIRED: "experience-content-type/id-required",
    EXPERIENCE_CONTENT_TYPE_NOT_FOUND: "experience-content-type/not-found",
    EXPERIENCE_CONTENT_TYPE_ORDER_INVALID: "experience-content-type/order-invalid",
    EXPERIENCE_CONTENT_TYPE_ORDER_REQUIRED: "experience-content-type/order-required",
    EXPERIENCE_CONTENT_TYPE_UPDATED: "experience-content-type/updated",
    EXPERIENCE_CONTENTS_ORDERED_INVALID: "experience/contents-ordered-invalid",
    EXPERIENCE_CONTENTS_ORDERED_REQUIRED: "experience/contents-ordered-required",
    EXPERIENCE_DELETED: "experience/deleted",
    EXPERIENCE_GRID_VIEW_INVALID: "experience/grid-view-invalid",
    EXPERIENCE_GRID_VIEW_REQUIRED: "experience/grid-view-required",
    EXPERIENCE_ID_INVALID: "experience/id-invalid",
    EXPERIENCE_ID_REQUIRED: "experience/id-required",
    EXPERIENCE_IDS_INVALID: "experience/ids-invalid",
    EXPERIENCE_IDS_REQUIRED: "experience/ids-required",
    EXPERIENCE_LANGUAGE_INVALID: "experience/language-invalid",
    EXPERIENCE_LANGUAGE_REQUIRED: "experience/language-required",
    EXPERIENCE_LEFT_DRAWER_INVALID: "experience/left-drawer-invalid",
    EXPERIENCE_LEFT_DRAWER_REQUIRED: "experience/left-drawer-required",
    EXPERIENCE_LOCKED_INVALID: "experience/locked-invalid",
    EXPERIENCE_LOCKED_REQUIRED: "experience/locked-required",
    EXPERIENCE_MEDIA_ITEM_ADDED: "experience-media-item/added",
    EXPERIENCE_MEDIA_ITEM_BULK_ADDED: "experience-media-item/bulk-added",
    EXPERIENCE_MEDIA_ITEM_BULK_DELETED: "experience-media-item/bulk-deleted",
    EXPERIENCE_MEDIA_ITEM_DELETED: "experience-media-item/deleted",
    EXPERIENCE_MEDIA_ITEM_EXISTS: "experience-media-item/exists",
    EXPERIENCE_MEDIA_ITEM_ID_INVALID: "experience-media-item/id-invalid",
    EXPERIENCE_MEDIA_ITEM_ID_REQUIRED: "experience-media-item/id-required",
    EXPERIENCE_MEDIA_ITEM_NOT_FOUND: "experience-media-item/not-found",
    EXPERIENCE_MEMBER_ADDED: "experience-member/added",
    EXPERIENCE_MEMBER_BULK_ADDED: "experience-member/bulk-added",
    EXPERIENCE_MEMBER_BULK_DELETED: "experience-member/bulk-deleted",
    EXPERIENCE_MEMBER_DELETED: "experience-member/deleted",
    EXPERIENCE_MEMBER_EXISTS: "experience-member/exists",
    EXPERIENCE_MEMBER_ID_INVALID: "experience-member/id-invalid",
    EXPERIENCE_MEMBER_ID_REQUIRED: "experience-member/id-required",
    EXPERIENCE_MEMBER_NOT_FOUND: "experience-member/not-found",
    EXPERIENCE_NOT_FOUND: "experience/not-found",
    EXPERIENCE_PRIMARY_FILTER_INVALID: "experience/primary-filter-invalid",
    EXPERIENCE_PRIMARY_FILTER_REQUIRED: "experience/primary-filter-required",
    EXPERIENCE_RIGHT_DRAWER_INVALID: "experience/right-drawer-invalid",
    EXPERIENCE_RIGHT_DRAWER_REQUIRED: "experience/right-drawer-required",
    EXPERIENCE_SEARCH_FIELD_INVALID: "experience/search-field-invalid",
    EXPERIENCE_SEARCH_FIELD_REQUIRED: "experience/search-field-required",
    EXPERIENCE_SEARCH_INVALID: "experience/search-invalid",
    EXPERIENCE_SEARCH_REQUIRED: "experience/search-required",
    EXPERIENCE_STATUS_INVALID: "experience/status-invalid",
    EXPERIENCE_STATUS_REQUIRED: "experience/status-required",
    EXPERIENCE_STATUSES_INVALID: "experience/statuses-invalid",
    EXPERIENCE_STATUSES_REQUIRED: "experience/statuses-required",
    EXPERIENCE_TAG_ADDED: "experience-tag/added",
    EXPERIENCE_TAG_EXISTS: "experience-tag/exists",
    EXPERIENCE_TAG_FILTER_INVALID: "experience/tag-filter-invalid",
    EXPERIENCE_TAG_FILTER_REQUIRED: "experience/tag-filter-required",
    EXPERIENCE_TAG_HIDDEN_INVALID: "experience-tag/hidden-invalid",
    EXPERIENCE_TAG_HIDDEN_REQUIRED: "experience-tag/hidden-required",
    EXPERIENCE_TAG_ID_INVALID: "experience-tag/id-invalid",
    EXPERIENCE_TAG_ID_REQUIRED: "experience-tag/id-required",
    EXPERIENCE_TAG_MEDIA_ITEM_ADDED: "experience-tag-media-item/added",
    EXPERIENCE_TAG_MEDIA_ITEM_EXISTS: "experience-tag-media-item/exists",
    EXPERIENCE_TAG_MEDIA_ITEM_HIDDEN_INVALID: "experience-tag-media-item/hidden-invalid",
    EXPERIENCE_TAG_MEDIA_ITEM_HIDDEN_REQUIRED: "experience-tag-media-item/hidden-required",
    EXPERIENCE_TAG_MEDIA_ITEM_ID_INVALID: "experience-tag-media-item/id-invalid",
    EXPERIENCE_TAG_MEDIA_ITEM_ID_REQUIRED: "experience-tag-media-item/id-required",
    EXPERIENCE_TAG_MEDIA_ITEM_NOT_FOUND: "experience-tag-media-item/not-found",
    EXPERIENCE_TAG_MEDIA_ITEM_ORDER_INVALID: "experience-tag-media-item/order-invalid",
    EXPERIENCE_TAG_MEDIA_ITEM_ORDER_REQUIRED: "experience-tag-media-item/order-required",
    EXPERIENCE_TAG_MEDIA_ITEM_UPDATED: "experience-tag-media-item/updated",
    EXPERIENCE_TAG_NAME_INVALID: "experience-tag/name-invalid",
    EXPERIENCE_TAG_NAME_REQUIRED: "experience-tag/name-required",
    EXPERIENCE_TAG_NOT_FOUND: "experience-tag/not-found",
    EXPERIENCE_TAG_ORDER_INVALID: "experience-tag/order-invalid",
    EXPERIENCE_TAG_ORDER_REQUIRED: "experience-tag/order-required",
    EXPERIENCE_TAG_UPDATED: "experience-tag/updated",
    EXPERIENCE_TAGS_TOGGLED_INVALID: "experience/tags-toggled-invalid",
    EXPERIENCE_TAGS_TOGGLED_REQUIRED: "experience/tags-toggled-required",
    EXPERIENCE_TITLE_INVALID: "experience/title-invalid",
    EXPERIENCE_TITLE_REQUIRED: "experience/title-required",
    EXPERIENCE_TYPE_FILTER_INVALID: "experience/type-filter-invalid",
    EXPERIENCE_TYPE_FILTER_REQUIRED: "experience/type-filter-required",
    EXPERIENCE_TYPE_TAG_FILTER_INVALID: "experience/type-tag-filter-invalid",
    EXPERIENCE_TYPE_TAG_FILTER_REQUIRED: "experience/type-tag-filter-required",
    EXPERIENCE_UNTITLED_INVALID: "experience/untitled-invalid",
    EXPERIENCE_UNTITLED_REQUIRED: "experience/untitled-required",
    EXPERIENCE_UPDATED: "experience/updated",
    FAVORITE_ADDED: "favorite/added",
    FAVORITE_DELETED: "favorite/deleted",
    FAVORITE_EXISTS: "favorite/exists",
    FAVORITE_ID_INVALID: "favorite/id-invalid",
    FAVORITE_ID_REQUIRED: "favorite/id-required",
    FAVORITE_NOT_FOUND: "favorite/not-found",
    FLAG_ADDED: "flag/added",
    FLAG_DELETED: "flag/deleted",
    FLAG_EXISTS: "flag/exists",
    FLAG_ID_INVALID: "flag/id-invalid",
    FLAG_ID_REQUIRED: "flag/id-required",
    FLAG_NAME_INVALID: "flag/name-invalid",
    FLAG_NAME_REQUIRED: "flag/name-required",
    FLAG_NOT_FOUND: "flag/not-found",
    FLAG_UPDATED: "flag/updated",
    FLAG_VALUE_INVALID: "flag/value-invalid",
    FLAG_VALUE_REQUIRED: "flag/value-required",
    HOTSPOT_ADDED: "hotspot/added",
    HOTSPOT_DELETED: "hotspot/deleted",
    HOTSPOT_ID_INVALID: "hotspot/id-invalid",
    HOTSPOT_ID_REQUIRED: "hotspot/id-required",
    HOTSPOT_LINKED_CONTENT_INVALID: "hotspot/linked-content-invalid",
    HOTSPOT_LINKED_CONTENT_REQUIRED: "hotspot/linked-content-required",
    HOTSPOT_NOT_FOUND: "hotspot/not-found",
    HOTSPOT_ORDER_INVALID: "hotspot/order-invalid",
    HOTSPOT_ORDER_REQUIRED: "hotspot/order-required",
    HOTSPOT_POSITION_DATA_INVALID: "hotspot/position-data-invalid",
    HOTSPOT_POSITION_DATA_REQUIRED: "hotspot/position-data-required",
    HOTSPOT_STATUS_INVALID: "hotspot/status-invalid",
    HOTSPOT_STATUS_REQUIRED: "hotspot/status-required",
    HOTSPOT_TITLE_INVALID: "hotspot/title-invalid",
    HOTSPOT_TITLE_REQUIRED: "hotspot/title-required",
    HOTSPOT_UPDATED: "hotspot/updated",
    ICON_ADDED: "icon/added",
    ICON_BULK_DELETED: "icon/bulk-deleted",
    ICON_DELETED: "icon/deleted",
    ICON_ID_INVALID: "icon/id-invalid",
    ICON_ID_REQUIRED: "icon/id-required",
    ICON_IDS_INVALID: "icon/ids-invalid",
    ICON_IDS_REQUIRED: "icon/ids-required",
    ICON_LINK_INVALID: "icon/link-invalid",
    ICON_LINK_REQUIRED: "icon/link-required",
    ICON_NAME_INVALID: "icon/name-invalid",
    ICON_NAME_REQUIRED: "icon/name-required",
    ICON_NOT_FOUND: "icon/not-found",
    ICON_UPDATED: "icon/updated",
    LIMIT_INVALID: "pagination/limit-invalid",
    LIMIT_REQUIRED: "pagination/limit-required",
    MEDIA_ITEM_ADDED: "media-item/added",
    MEDIA_ITEM_ALT_TEXT_INVALID: "media-item/alt-text-invalid",
    MEDIA_ITEM_ALT_TEXT_REQUIRED: "media-item/alt-text-required",
    MEDIA_ITEM_ARIA_LABEL_INVALID: "media-item/aria-label-invalid",
    MEDIA_ITEM_ARIA_LABEL_REQUIRED: "media-item/aria-label-required",
    MEDIA_ITEM_BULK_ADDED: "media-item/bulk-added",
    MEDIA_ITEM_BULK_DELETED: "media-item/bulk-deleted",
    MEDIA_ITEM_CODE_INVALID: "media-item/code-invalid",
    MEDIA_ITEM_CODE_REQUIRED: "media-item/code-required",
    MEDIA_ITEM_DELETED: "media-item/deleted",
    MEDIA_ITEM_DESCRIPTION_INVALID: "media-item/description-invalid",
    MEDIA_ITEM_DESCRIPTION_REQUIRED: "media-item/description-required",
    MEDIA_ITEM_FILE_EXTENSION_INVALID: "media-item/file-extension-invalid",
    MEDIA_ITEM_FILE_EXTENSION_REQUIRED: "media-item/file-extension-required",
    MEDIA_ITEM_FILE_SIZE_INVALID: "media-item/file-size-invalid",
    MEDIA_ITEM_FILE_SIZE_REQUIRED: "media-item/file-size-required",
    MEDIA_ITEM_FILE_TYPE_INVALID: "media-item/file-type-invalid",
    MEDIA_ITEM_FILE_TYPE_REQUIRED: "media-item/file-type-required",
    MEDIA_ITEM_ID_INVALID: "media-item/id-invalid",
    MEDIA_ITEM_ID_REQUIRED: "media-item/id-required",
    MEDIA_ITEM_IDS_INVALID: "media-item/ids-invalid",
    MEDIA_ITEM_IDS_REQUIRED: "media-item/ids-required",
    MEDIA_ITEM_LINK_INVALID: "media-item/link-invalid",
    MEDIA_ITEM_LINK_REQUIRED: "media-item/link-required",
    MEDIA_ITEM_MEMBER_ADDED: "media-item-member/added",
    MEDIA_ITEM_MEMBER_BULK_ADDED: "media-item-member/bulk-added",
    MEDIA_ITEM_MEMBER_BULK_DELETED: "media-item-member/bulk-deleted",
    MEDIA_ITEM_MEMBER_DELETED: "media-item-member/deleted",
    MEDIA_ITEM_MEMBER_EXISTS: "media-item-member/exists",
    MEDIA_ITEM_MEMBER_ID_INVALID: "media-item-member/id-invalid",
    MEDIA_ITEM_MEMBER_ID_REQUIRED: "media-item-member/id-required",
    MEDIA_ITEM_MEMBER_NOT_FOUND: "media-item-member/not-found",
    MEDIA_ITEM_NAME_INVALID: "media-item/name-invalid",
    MEDIA_ITEM_NAME_REQUIRED: "media-item/name-required",
    MEDIA_ITEM_NOT_FOUND: "media-item/not-found",
    MEDIA_ITEM_OG_TITLE_INVALID: "media-item/og-title-invalid",
    MEDIA_ITEM_OG_TITLE_REQUIRED: "media-item/og-title-required",
    MEDIA_ITEM_ROOM_ID_INVALID: "media-item/room-id-invalid",
    MEDIA_ITEM_ROOM_ID_REQUIRED: "media-item/room-id-required",
    MEDIA_ITEM_SCENE_DEFAULT_VIEW_INVALID: "media-item/scene-default-view-invalid",
    MEDIA_ITEM_SCENE_DEFAULT_VIEW_REQUIRED: "media-item/scene-default-view-required",
    MEDIA_ITEM_SCENE_DESCRIPTION_INVALID: "media-item/scene-description-invalid",
    MEDIA_ITEM_SCENE_DESCRIPTION_REQUIRED: "media-item/scene-description-required",
    MEDIA_ITEM_SCENE_ID_INVALID: "media-item/scene-id-invalid",
    MEDIA_ITEM_SCENE_ID_REQUIRED: "media-item/scene-id-required",
    MEDIA_ITEM_SUPPORTED_URL_INVALID: "media-item/supported-url-invalid",
    MEDIA_ITEM_SUPPORTED_URL_REQUIRED: "media-item/supported-url-required",
    MEDIA_ITEM_TAG_ADDED: "media-item-tag/added",
    MEDIA_ITEM_TAG_BULK_ADDED: "media-item-tag/bulk-added",
    MEDIA_ITEM_TAG_BULK_DELETED: "media-item-tag/bulk-deleted",
    MEDIA_ITEM_TAG_DELETED: "media-item-tag/deleted",
    MEDIA_ITEM_TAG_EXISTS: "media-item-tag/exists",
    MEDIA_ITEM_TAG_ID_INVALID: "media-item-tag/id-invalid",
    MEDIA_ITEM_TAG_ID_REQUIRED: "media-item-tag/id-required",
    MEDIA_ITEM_TAG_NOT_FOUND: "media-item-tag/not-found",
    MEDIA_ITEM_TRANSCRIPT_INVALID: "media-item/transcript-invalid",
    MEDIA_ITEM_TRANSCRIPT_REQUIRED: "media-item/transcript-required",
    MEDIA_ITEM_TYPE_INVALID: "media-item/type-invalid",
    MEDIA_ITEM_TYPE_REQUIRED: "media-item/type-required",
    MEDIA_ITEM_UPDATED: "media-item/updated",
    MEDIA_ITEM_X_FRAME_OPTIONS_INVALID: "media-item/x-frame-options-invalid",
    MEDIA_ITEM_X_FRAME_OPTIONS_REQUIRED: "media-item/x-frame-options-required",
    MEMBER_DELETED: "member/deleted",
    MEMBER_EXISTS: "member/exists",
    MEMBER_ID_INVALID: "member/id-invalid",
    MEMBER_ID_REQUIRED: "member/id-required",
    MEMBER_IDS_INVALID: "member/ids-invalid",
    MEMBER_IDS_REQUIRED: "member/ids-required",
    MEMBER_INVITED: "member/invited",
    MEMBER_NOT_FOUND: "member/not-found",
    MEMBER_UPDATED: "member/updated",
    MESSAGE_ADDED: "message/added",
    MESSAGE_DELETED: "message/deleted",
    MESSAGE_ID_INVALID: "message/id-invalid",
    MESSAGE_ID_REQUIRED: "message/id-required",
    MESSAGE_NOT_FOUND: "message/not-found",
    MESSAGE_SENDER_EMAIL_INVALID: "message/sender-email-invalid",
    MESSAGE_SENDER_EMAIL_REQUIRED: "message/sender-email-required",
    MESSAGE_SENDER_NAME_INVALID: "message/sender-name-invalid",
    MESSAGE_SENDER_NAME_REQUIRED: "message/sender-name-required",
    MESSAGE_SENDER_PHONE_INVALID: "message/sender-phone-invalid",
    MESSAGE_SENDER_PHONE_REQUIRED: "message/sender-phone-required",
    MESSAGE_SENDER_TEXT_INVALID: "message/sender-text-invalid",
    MESSAGE_SENDER_TEXT_REQUIRED: "message/sender-text-required",
    MESSAGE_SHARE_URL_INVALID: "message/share-url-invalid",
    MESSAGE_SHARE_URL_REQUIRED: "message/share-url-required",
    MESSAGE_TYPE_INVALID: "message/type-invalid",
    MESSAGE_TYPE_REQUIRED: "message/type-required",
    MISSING_FIELDS: "request/missing-fields",
    NOTIFICATION_BULK_DELETED: "notification/bulk-deleted",
    NOTIFICATION_BULK_UPDATED: "notification/bulk-updated",
    NOTIFICATION_DELETED: "notification/deleted",
    NOTIFICATION_ID_INVALID: "notification/id-invalid",
    NOTIFICATION_ID_REQUIRED: "notification/id-required",
    NOTIFICATION_IDS_INVALID: "notification/ids-invalid",
    NOTIFICATION_IDS_REQUIRED: "notification/ids-required",
    NOTIFICATION_NOT_FOUND: "notification/not-found",
    NOTIFICATION_OPENED_INVALID: "notification/opened-invalid",
    NOTIFICATION_OPENED_REQUIRED: "notification/opened-required",
    NOTIFICATION_READ_INVALID: "notification/read-invalid",
    NOTIFICATION_READ_REQUIRED: "notification/read-required",
    NOTIFICATION_UPDATED: "notification/updated",
    OFFSET_INVALID: "pagination/offset-invalid",
    OFFSET_REQUIRED: "pagination/offset-required",
    PHONE_CODE_INVALID: "phone/code-invalid",
    PHONE_CODE_REQUIRED: "phone/code-required",
    PHONE_INVALID: "phone/invalid",
    PHONE_ISO_INVALID: "phone/iso-invalid",
    PHONE_ISO_REQUIRED: "phone/iso-required",
    PHONE_NUMBER_INVALID: "phone/number-invalid",
    PHONE_NUMBER_REQUIRED: "phone/number-required",
    PHONE_NUMBER_VALID: "phone/number-valid",
    PHONE_REQUIRED: "phone/required",
    PHONE_TYPE_INVALID: "phone/type-invalid",
    PHONE_TYPE_REQUIRED: "phone/type-required",
    PROFILE_DELETED: "profile/deleted",
    PROFILE_UPDATED: "profile/updated",
    PROPERTY_ADDED: "property/added",
    PROPERTY_CODE_INVALID: "property/code-invalid",
    PROPERTY_CODE_MAX_LENGTH: "property/code-max-length",
    PROPERTY_CODE_REQUIRED: "property/code-required",
    PROPERTY_ID_INVALID: "property/id-invalid",
    PROPERTY_ID_REQUIRED: "property/id-required",
    PROPERTY_NAME_INVALID: "property/name-invalid",
    PROPERTY_NAME_REQUIRED: "property/name-required",
    PROPERTY_NOT_FOUND: "property/not-found",
    PROPERTY_STATUS_INVALID: "property/status-invalid",
    PROPERTY_STATUS_REQUIRED: "property/status-required",
    PROPERTY_SUBDOMAIN_EXISTS: "property/subdomain-exists",
    PROPERTY_SUBDOMAIN_INVALID: "property/subdomain-invalid",
    PROPERTY_SUBDOMAIN_MAX_LENGTH: "property/subdomain-max-length",
    PROPERTY_SUBDOMAIN_REQUIRED: "property/subdomain-required",
    PROPERTY_TYPE_INVALID: "property/type-invalid",
    PROPERTY_TYPE_REQUIRED: "property/type-required",
    PROPERTY_UPDATED: "property/updated",
    SEARCH_ADDED: "search/added",
    SEARCH_DELETED: "search/deleted",
    SEARCH_EXISTS: "search/exists",
    SEARCH_ID_INVALID: "search/id-invalid",
    SEARCH_ID_REQUIRED: "search/id-required",
    SEARCH_NOT_FOUND: "search/not-found",
    SEARCH_TEXT_INVALID: "search/text-invalid",
    SEARCH_TEXT_MIN_LENGTH: "search/text-min-length",
    SHARE_ADDED: "share/added",
    SHARE_DELETED: "share/deleted",
    SHARE_EMAIL_INVALID: "share/email-invalid",
    SHARE_EMAIL_REQUIRED: "share/email-required",
    SHARE_EMAILS_INVALID: "share/emails-invalid",
    SHARE_EMAILS_REQUIRED: "share/emails-required",
    SHARE_EXISTS: "share/exists",
    SHARE_HAS_OPENED_INVALID: "share/has-opened-invalid",
    SHARE_HAS_OPENED_REQUIRED: "share/has-opened-required",
    SHARE_ID_INVALID: "share/id-invalid",
    SHARE_ID_REQUIRED: "share/id-required",
    SHARE_MESSAGE_INVALID: "share/message-invalid",
    SHARE_MESSAGE_REQUIRED: "share/message-required",
    SHARE_NOT_FOUND: "share/not-found",
    SHARE_OPTIONS_INVALID: "share/options-invalid",
    SHARE_OPTIONS_REQUIRED: "share/options-required",
    SHARE_PHONE_INVALID: "share/phone-invalid",
    SHARE_PHONE_NUMBER_INVALID: "share/phone-number-invalid",
    SHARE_PHONE_NUMBER_REQUIRED: "share/phone-number-required",
    SHARE_PHONE_NUMBERS_INVALID: "share/phone-numbers-invalid",
    SHARE_PHONE_NUMBERS_REQUIRED: "share/phone-numbers-required",
    SHARE_PHONE_REQUIRED: "share/phone-required",
    SHARE_TITLE_INVALID: "share/title-invalid",
    SHARE_TITLE_REQUIRED: "share/title-required",
    SHARE_TYPE_INVALID: "share/type-invalid",
    SHARE_TYPE_REQUIRED: "share/type-required",
    SHARE_UPDATED: "share/updated",
    SHARE_URL_INVALID: "share/url-invalid",
    SHARE_URL_REQUIRED: "share/url-required",
    SORT_FIELD_INVALID: "sort/field-invalid",
    SORT_FIELD_REQUIRED: "sort/field-required",
    SORT_ORIENTATION_INVALID: "sort/orientation-invalid",
    SORT_ORIENTATION_REQUIRED: "sort/orientation-required",
    TAG_ADDED: "tag/added",
    TAG_BULK_UPDATED: "tag/bulk-updated",
    TAG_DELETED: "tag/deleted",
    TAG_EXISTS: "tag/exists",
    TAG_HIDDEN_INVALID: "tag/hidden-invalid",
    TAG_HIDDEN_REQUIRED: "tag/hidden-required",
    TAG_ID_INVALID: "tag/id-invalid",
    TAG_ID_REQUIRED: "tag/id-required",
    TAG_IDS_INVALID: "tag/ids-invalid",
    TAG_IDS_REQUIRED: "tag/ids-required",
    TAG_NAME_INVALID: "tag/name-invalid",
    TAG_NAME_REQUIRED: "tag/name-required",
    TAG_NAMES_INVALID: "tag/names-invalid",
    TAG_NAMES_REQUIRED: "tag/names-required",
    TAG_NOT_FOUND: "tag/not-found",
    TAG_ORDER_INVALID: "tag/order-invalid",
    TAG_ORDER_REQUIRED: "tag/order-required",
    TAG_UPDATED: "tag/updated",
    UNAUTHORIZED: "auth/unauthorized",
    UNIV_CATEGORY_ADDED: "univ-category/added",
    UNIV_CATEGORY_DELETED: "univ-category/deleted",
    UNIV_CATEGORY_EXISTS: "univ-category/exists",
    UNIV_CATEGORY_ID_INVALID: "univ-category/id-invalid",
    UNIV_CATEGORY_ID_REQUIRED: "univ-category/id-required",
    UNIV_CATEGORY_NAME_INVALID: "univ-category/name-invalid",
    UNIV_CATEGORY_NAME_REQUIRED: "univ-category/name-required",
    UNIV_CATEGORY_NOT_FOUND: "univ-category/not-found",
    UNIV_CATEGORY_ORDER_INVALID: "univ-category/order-invalid",
    UNIV_CATEGORY_ORDER_REQUIRED: "univ-category/order-required",
    UNIV_CATEGORY_UPDATED: "univ-category/updated",
    UNIV_VIDEO_ADDED: "univ-video/added",
    UNIV_VIDEO_CATEGORY_INVALID: "univ-video/category-invalid",
    UNIV_VIDEO_CATEGORY_REQUIRED: "univ-video/category-required",
    UNIV_VIDEO_DELETED: "univ-video/deleted",
    UNIV_VIDEO_DESCRIPTION_INVALID: "univ-video/description-invalid",
    UNIV_VIDEO_DESCRIPTION_REQUIRED: "univ-video/description-required",
    UNIV_VIDEO_DURATION_INVALID: "univ-video/duration-invalid",
    UNIV_VIDEO_DURATION_REQUIRED: "univ-video/duration-required",
    UNIV_VIDEO_ID_INVALID: "univ-video/id-invalid",
    UNIV_VIDEO_ID_REQUIRED: "univ-video/id-required",
    UNIV_VIDEO_NOT_FOUND: "univ-video/not-found",
    UNIV_VIDEO_ORDER_INVALID: "univ-video/order-invalid",
    UNIV_VIDEO_ORDER_REQUIRED: "univ-video/order-required",
    UNIV_VIDEO_SHARE_URL_INVALID: "univ-video/share-url-invalid",
    UNIV_VIDEO_SHARE_URL_REQUIRED: "univ-video/share-url-required",
    UNIV_VIDEO_THUMBNAIL_LARGE_INVALID: "univ-video/thumbnail-large-invalid",
    UNIV_VIDEO_THUMBNAIL_LARGE_REQUIRED: "univ-video/thumbnail-large-required",
    UNIV_VIDEO_THUMBNAIL_MEDIUM_INVALID: "univ-video/thumbnail-medium-invalid",
    UNIV_VIDEO_THUMBNAIL_MEDIUM_REQUIRED: "univ-video/thumbnail-medium-required",
    UNIV_VIDEO_THUMBNAIL_SMALL_INVALID: "univ-video/thumbnail-small-invalid",
    UNIV_VIDEO_THUMBNAIL_SMALL_REQUIRED: "univ-video/thumbnail-small-required",
    UNIV_VIDEO_TITLE_INVALID: "univ-video/title-invalid",
    UNIV_VIDEO_TITLE_REQUIRED: "univ-video/title-required",
    UNIV_VIDEO_UPDATED: "univ-video/updated",
    UNIV_VIDEO_URL_INVALID: "univ-video/url-invalid",
    UNIV_VIDEO_URL_REQUIRED: "univ-video/url-required",
    VIEW_ADDED: "view/added",
    VIEW_DELETED: "view/deleted",
    VIEW_EXISTS: "view/exists",
    VIEW_ID_INVALID: "view/id-invalid",
    VIEW_ID_REQUIRED: "view/id-required",
    VIEW_NOT_FOUND: "view/not-found",
    ASSET_CATEGORY_NOT_FOUND: "asset-category/not-found",
    ASSET_CATEGORY_ID_INVALID: "asset-category/id-invalid",
    ASSET_CATEGORY_ID_REQUIRED: "asset-category/id-required",
    ASSET_CATEGORY_IDS_INVALID: "asset-category/ids-invalid",
    ASSET_CATEGORY_IDS_REQUIRED: "asset-category/ids-required",
    ASSET_CATEGORY_NAME_INVALID: "asset-category/name-invalid",
    ASSET_CATEGORY_NAME_REQUIRED: "asset-category/name-required",
    ASSET_CATEGORY_UPDATED: "asset-category/updated",
    ASSET_CATEGORY_ADDED: "asset-category/added",
    ASSET_CATEGORY_BULK_DELETED: "asset-category/bulk-deleted",
};
